import { create } from 'zustand';

export interface ICollapsiblePreviewCampaignState {
  expandedPreviewCampaigns: Record<string, boolean>;
}

export interface ICollapsiblePreviewCampaignActions {
  togglePreviewCampaign: (previewCampaignId: string) => void;
  collapseAll: () => void;
}

export type ICollapsiblePreviewCampaignStore = ICollapsiblePreviewCampaignState &
  ICollapsiblePreviewCampaignActions;

export const useCollapsiblePreviewCampaignStore = create<ICollapsiblePreviewCampaignStore>(
  (set) => ({
    expandedPreviewCampaigns: {},

    togglePreviewCampaign: (previewCampaignId) =>
      set((state) => {
        const isExpanded = state.expandedPreviewCampaigns[previewCampaignId];

        if (isExpanded) {
          const { [previewCampaignId]: _removed, ...rest } = state.expandedPreviewCampaigns;
          return {
            expandedPreviewCampaigns: rest,
          };
        }
        return {
          expandedPreviewCampaigns: {
            ...state.expandedPreviewCampaigns,
            [previewCampaignId]: true,
          },
        };
      }),

    collapseAll: () => set(() => ({ expandedPreviewCampaigns: {} })),
  }),
);
